<template>
  <div class="operation-log">
    <div class="social-right">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
  </div>
</template>

<script>
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import publicAPI from "../../../../api-path/public-api.js";
export default {
  components: {
    TabelSearch,
  },
  data() {
    return {
      switchVal: true,
      //表格start
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            placeholder: "开始时间:结束时间",
            valueType: "datetimerange",
            key: "date",
          },
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      searchParams: {
        date: "",
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [],
      tableTemplateData: [],
      tableConfig: {
        rows: [
          {
            label: "ID",
            prop: "id",
          },
          {
            label: "姓名",
            prop: "userName",
          },
          {
            label: "时间",
            prop: "createGmt",
          },
          {
            label: "菜单模块",
            prop: "module",
          },
          // {
          // 	label: '类型',
          // 	prop: 'createGmt'
          // },
          {
            label: "操作详情",
            prop: "description",
          },
          {
            label: "IP",
            prop: "ip",
          },
        ],
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //表格end
    };
  },
  created() {
    this.setSearchParams();
  },
  mounted() {},
  methods: {
    resetCallBack() {
      this.searchParams.date = [];
      this.searchParams.search = "";
      this.searchParams.page = this.pagination.page=1;
      this.searchParams.size = this.pagination.size=15;
      this.setSearchParams();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams();
    },
    setSearchParams(value) {
      const { date, ...params } = { ...this.searchParams };
      params.startTime = date[0];
      params.endTime = date[1];
      if (value) {
        this.pagination.page = value.page;
      }
      this.$http.get(publicAPI.logListPage, { params }).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.tableTemplateData = res.result.pageList;
          this.pagination.total = res.result.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.operation-log {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .social-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .social-right {
	flex: 1;
	display: flex;
	flex-direction: column;
  }

  //查看
  .form-detail {
    height: 50vh;
    overflow-y: scroll;
    .info-list {
      .clues-title {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
      }
    }
    .user-info {
      display: flex;
      // background: #e7f6fb;
      padding: 10px;
      border-radius: 5px;

      .user-detail {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 80px;
        margin-left: 20px;
        flex: 1;
      }
    }

    .item-box {
      display: flex;
      margin-top: 20px;
      position: relative;
      align-items: center;

      .status {
        position: absolute;
        right: 0;
        color: red;
      }
    }
  }

  .form-btn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .input-label {
    .input {
      margin: 30px 0;
      .el-textarea {
        width: 100%;
      }
    }
  }
  .ignore-btn {
    display: flex;
    justify-content: center;
  }
  //是否有偿
  .money-box {
    display: flex;
    margin-bottom: 30px;
    .label {
      width: 100px;
      text-align: right;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    .money {
      display: flex;
      flex-direction: column;
      .el-input-number {
        width: auto;
      }
      .money-input {
        margin: 10px 0 0 0;
      }
    }
  }
}
</style>
